// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../src/flash_message"
import "../src/submitting"
import "../src/input_text_other"
import "../src/clicked_appear"
import "../src/form_answer_checkbox_validation"
import "../src/admin/navigation"
import "../src/admin/form_section"
import "../src/admin/form_explanation_table"
import "../src/admin/action_text_image_upload_validation"

require('jquery')
require('jquery-ui/ui/widgets/sortable.js')

Rails.start()
// Turbolinks.start()
ActiveStorage.start()

require("trix")
require("@rails/actiontext")
